module.exports = __webpack_public_path__ + "static/img/205.1e7406cd.png";